























import { Vue, Component, Prop } from 'vue-property-decorator'
import { popup } from '@lx-frontend/cvux'
import { ExitRuleItem } from '../indexType'

@Component({
  components: {
    popup
  }
})
export default class OutRulesPopup extends Vue {
  @Prop(Array) readonly list!: ExitRuleItem[];
  @Prop(Number) readonly id!: number;

  show = false

  selectId = 0
  selectName = ''

  handleSelectCar(option: ExitRuleItem) {
    this.selectId = option.rule_id
    this.selectName = option.rule_name
  }

  changeShow(v:boolean) {
    if (v) this.selectId = this.id
    this.show = v
  }

  handleSubmit() {
    const { selectName, selectId } = this
    this.$emit('select', {
      rule_id: selectId,
      rule_name: selectName
    })
    this.changeShow(false)
  }
}
